import { PropsWithChildren, createContext, useContext } from 'react';

import { SessionContextValue, SessionMode } from '@/features/session/types';
import { useSessionMachine } from '@/features/session/useSessionMachine';

const SessionContext = createContext<SessionContextValue | null>(null);

/** The chat's own session for the route's mode: the panel (`embed`) or the full page (`page`). */
export const SessionProvider = ({
  mode,
  children,
}: PropsWithChildren<{ mode: SessionMode }>) => {
  const value = useSessionMachine(mode);

  return (
    <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
  );
};

export const useSession = (): SessionContextValue => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }

  return context;
};
